<template lang='pug'>
  v-container.px-3.expenses-container(fluid)
    v-dialog( :fullscreen="isMobile" width="500" persistent :value='detailsDialog' transition="dialog-bottom-transition")
      Details(v-if='detailsDialog' :request='currentRequest' @close ='detailsDialog=false' admin="expense")
    // Bill
    v-dialog( persistent  :value='showBillDialog'  max-width='600px' transition="dialog-bottom-transition")
      div(style='position:relative; height: 100%;')
        bill-preview(@close="showBillDialog=false" @showSupportImage='showSupportImage' :item="currentTransaction" :currentType = 'currentType' )
    // Create
    v-dialog(:fullscreen="isMobile" persistent  :value='expensesDialog'  max-width='800px'   transition="dialog-bottom-transition" )
      ExpensesForm(v-if='expensesDialog' :model="currentItem" @close="expensesDialog = false; fetch()")
    // Delete
    v-dialog(v-model='confirmationDialog' width="400px" persistent)
      v-card.pa-2
          v-card-title.headline {{$t('expenses.delete_expense')}}
          v-card-text
              | {{$t('expenses.delete_question')}}
          v-card-actions
              v-spacer
              v-btn(color='green darken-1', flat='', @click.native='confirmationDialog = false') No, cancelar
              v-btn(color='red darken-1', flat='', @click.native='deleteItem(currentItemDelete)') Si, proceder
    v-row.px-3.justify-space-between.align-center.my-0
      v-col.d-flex.justify-end(cols="12")
        //- Update btn
        v-btn.main-btn-gradient(small style="height: 48px;" @click="fetch()")
          v-icon mdi-refresh
        //- Date filter
        v-menu(v-model='menu', :close-on-content-click='false', :nudge-width='200', nudge-top offset-x='')
          template(v-slot:activator='{ on }')
            v-btn.main-btn-gradient(small color='#3cbbc2', dark='', v-on='on' style="height: 48px;").mt-0
              v-icon mdi-calendar
              | {{$t('expenses.dates')}}
          v-card(style="border:3px solid #3cbbc2;").pa-2
            date-filter(@closeMenu="menu = false; loading = true" :currentType= 'currentType',)
    v-row.px-5.my-0
      MovementTransactions(
        title="Movimientos gastos"
        :movements="transactions.length.toString() || '0'"
        :total="transactionTotals.total.toFixed(2)"
        utility=""
      )
    v-row.px-5.my-0
      v-card.rounded-lg.pa-3( width="100%")
        v-row
          v-col.pb-0(cols="12" xs="6" sm="6" md="4")
            v-select.rounded-xl(
              :label="$t('expenses.filter_by_store')",
              elevation=0
              outlined
              :items='field.locations || []',
              v-model='currentLocation',
              item-text='full_name',
              return-object, dense='', solo='',
              clearable='', @input='selectShop',
              @click:clear='clearShopSelection')
                template(v-if='data.item' slot='selection', slot-scope='data')
                  v-flex(xs2='')
                    v-avatar(size='25px')
                      img( v-if='!!data.item' width='25' style='object-fit:cover;' :src='data.item.pictures.imageInput1')
                  v-flex.ml-1(style='font-size:10px; color :#000;')
                    | {{ data.item.name }}
                template(v-if='data.item' slot='item', slot-scope='data' )
                  v-row.my-1
                    v-avatar
                      img(v-if='!!data.item' width='25' style='object-fit:cover;' :src='data.item.pictures.imageInput1')
                    b {{data.item.name}}
          v-col.pb-0.d-flex.create-btn(cols="12" xs="6" sm="6" md="8")
            v-btn.main-btn-gradient(small @click="createItem" style="height: 48px;").mt-0
              v-icon mdi-plus
              | Agregar {{$t('expenses.expenses_bill')}}
        v-row
          v-col(cols='12' md='12')
            .card-transactions
              v-progress-linear(v-if="loading" indeterminate color="#008e95")
              .show-table-desktop
                v-data-table.elevation-0(:headers="headers" :items="transactions || []" item-key="name" :search="search")
                  template(v-slot:item="props")
                    tr(@click="openDetail(props.item)" style="cursor: pointer;")
                      td.text-xs-left(style="max-width:250px;") {{ props.item.title | shortName}}
                      td.text-xs-left(style="max-width:250px;") {{ props.item.description | shortName}}
                      td.text-xs-left {{ props.item.time | moment }} {{props.item.time | momentHours}}
                      td.text-xs-left {{ props.item.amount | numberFormat}}
                      td.text-xs-left {{ props.item.typeExpense}}
                      td.text-xs-left {{ props.item.location_to.name}}
                      td.text-xs-left
                        v-btn(fab dark small text color='green' @click.stop='editItem(props.item)')
                            v-icon(small) mdi-pen
                        v-btn(fab dark small text color='red'  @click.stop='openDeleteDialog(props.item)')
                            v-icon(small) mdi-delete
              v-list.show-table-mobile(two-line="" v-if="filteredTransactions && filteredTransactions.length > 0")
                v-list-item-group(style="width: 100%;")
                  template(v-for="(item, index) in filteredTransactions.slice(10*(page-1), 10*(page))")
                    v-list-item(:key="item.reference_number").notification
                        template(v-slot:default="{ active, toggle }")
                            v-list-item-content(@click="openDetail(item)")
                                p.font-weight-bold {{ item.title}}
                                p.mt-2 {{ item.location_to.name}}
                                p.mt-2.notification__date {{item.time | moment}} {{item.time | momentHours}}
                                p.mt-2 {{ item.description}}
                                p.mt-2 {{ item.typeExpense}}
                                p.mt-2.font-weight-bold.notification__price {{ item.amount | numberFormat}}
                            v-lis-item-action
                              v-btn(text dark small color='green' @click.stop='editItem(item)')
                                v-icon(small) mdi-pen
                              v-btn(text dark small color='red'  @click.stop='openDeleteDialog(item)')
                                v-icon(small) mdi-delete
                        v-divider(v-if="index + 1 < filteredTransactions.length" :key="index")
                  v-pagination.my-4(v-model="page" :length="pageNumber")
              .show-table-mobile(v-else)
                NoResults(title="No tienes gastos", description="Puedes ver tus gastos en otro rango de fechas")
    //- old content
    //- v-layout(wrap='')
      v-flex(md12='', v-show="getCurrentType !== null || field!==null || sold!==null" :style="isMobile ? 'padding-left: 20px !important; padding-right: 20px !important;': ''")
        // v-btn(color="#009da5" fab small dark="" v-if="isMobile" @click="$router.go(-1)").mt-2.ml-5
          v-icon(size="25") mdi-arrow-left
        v-col(v-if="isMobile" cols="12" style="position: relative;")
          v-icon(style="z-index: 10; position: absolute; left: 0; top: 0;" size="65" color="#30b5bb" @click="$router.go(-1)") mdi-chevron-left
          h2.expenses__title.expenses__underline Gastos
        v-card(v-if="!isMobile")
          v-card-title.mb-4 {{$t('expenses.title')}}
          .text-center(style="display:flex; align-items:flex-start;margin-left: 25px !important").mt-2
            //- v-menu(v-model='menu', :close-on-content-click='false', :nudge-width='200', nudge-top offset-x='')
              template(v-slot:activator='{ on }')
                v-btn(color='#3cbbc2', dark='', v-on='on' style="height: 48px;").mt-0
                  v-icon mdi-calendar
                  | {{$t('expenses.dates')}}
              v-card(style="border:3px solid #3cbbc2;").pa-2
                date-filter(@closeMenu="menu = false; loading = true" :currentType= 'currentType',)
            .text-center(style="display:flex; align-items:center;")
              v-select.elevation-0(
              :label="$t('expenses.filter_by_store')",
              :items='field.locations || []',
              v-model='currentLocation',
              item-text='full_name',
              return-object, dense='', solo='',
              clearable='', @input='selectShop',
              @click:clear='clearShopSelection')
                template(v-if='data.item' slot='selection', slot-scope='data')
                  v-flex(xs2='')
                    v-avatar(size='25px')
                      img( v-if='!!data.item' width='25' style='object-fit:cover;' :src='data.item.pictures.imageInput1')
                  v-flex.ml-1(style='font-size:10px; color :#000;')
                    | {{ data.item.name }}
                template(v-if='data.item' slot='item', slot-scope='data' )
                  v-row
                    v-avatar
                      img(v-if='!!data.item' width='25' style='object-fit:cover;' :src='data.item.pictures.imageInput1')
                    b {{data.item.name}}
            //-
              v-btn(v-if="!isMobile" medium color='#3cbbc2' @click="createItem").mx-8
                v-icon(left='' small) mdi-plus
                | {{$t('expenses.expenses_bill')}}
            v-card(style='margin: 2px;' flat link @click="createItem" outlined).category-card.py-6.mx-4
              v-layout(pa-1 pl-2).text-center
                v-layout(xs12='' style="z-index: 0;").justify-space-around.align-center
                  span.h2.text-uppercase.text-center.d-flex.justify-center.align-center(style="width: 350px;") Agregar {{$t('expenses.expenses_bill')}}
                    img.mr-4.ml-2(style='height:36px' :src="addExpenseIcon")
            //- v-card(style='margin: 2px;' flat link  @click="fetch()" outlined).category-card.py-6.mx-4
              v-layout(pa-1 pl-2).text-center
                v-layout(xs12='' style="z-index: 0;").justify-space-around.align-center
                  span.h2.text-uppercase.text-center.d-flex.justify-center.align-center(style="width: 200px;") Actualizar
                    v-icon mdi-refresh
                    //- img.mr-4.ml-2(style='height:36px' :src="updateIcon")
          v-row.mt-2.mb-8.pr-4(v-if="isMobile")
                    img.mr-4.ml-2(style='height:36px' :src="updateIcon")
          //-
            v-card(v-if="isMobile" style='margin: 2px;' flat link @click="createItem" height="20" outlined).category-card.py-6.mx-4
              v-layout(pa-1 pl-2).text-center
                v-layout(xs12='' style="z-index: 0;").justify-space-around.align-center
                  span.h2.text-uppercase.text-center.d-flex.justify-center.align-center(style="width: 350px;") Agregar {{$t('expenses.expenses_bill')}}
                    img.mr-4.ml-2(style='height:36px' :src="addExpenseIcon")
            v-card(v-if="isMobile" style='margin: 2px;' flat link @click="fetch()" height="20" outlined).category-card.py-6.mx-4.mb-8
              v-layout(pa-1 pl-2).text-center
                v-layout(xs12='' style="z-index: 0;").justify-space-around.align-center
                  span.h2.text-uppercase.text-center.d-flex.justify-center.align-center(style="width: 350px;") Actualizar
                    img.mr-4.ml-2(style='height:36px' :src="updateIcon")
          // Card
          v-layout.bill-action__button-row().my-2
            v-flex(style='display:flex; flex-direction: row; flex-wrap: wrap; justify-content:flex-start; align-items:center;')
              v-flex(sm6='', xs12='', md6='', lg4='')
                base-material-stats-card( v-if ='!!transactions'  color='warning', icon='mdi-swap-vertical', small-value='#' :title="$t('expenses.movements')", :value='transactions.length.toString()')
              v-flex(sm6='', xs12='', md6='', lg4='')
                base-material-stats-card( color='cyan', icon='mdi-currency-usd', small-value='$' :title="$t('expenses.total')", :value=' transactionTotals.total.toFixed(2)')
          v-card
            v-progress-linear(v-if="loading" indeterminate color="cyan")
            v-card-title
              v-text-field(v-model='search', append-outer-icon='mdi-search', :label="$t('expenses.search')", single-line='', hide-details='')
            v-data-table.elevation-1(:headers="headers" :items="transactions || []" item-key="name" :search="search")
              template(v-slot:item="props")
                tr(@click="openDetail(props.item)" style="cursor: pointer;")
                  td.text-xs-left(style="max-width:250px;") {{ props.item.title | shortName}}
                  td.text-xs-left(style="max-width:250px;") {{ props.item.description | shortName}}
                  td.text-xs-left {{ props.item.time | moment }} {{props.item.time | momentHours}}
                  td.text-xs-left {{ props.item.amount | numberFormat}}
                  td.text-xs-left {{ props.item.typeExpense}}
                  td.text-xs-left {{ props.item.location_to.name}}
                  td.text-xs-left
                    v-btn(fab dark small color='green' @click.stop='editItem(props.item)')
                        v-icon(small) mdi-pen
                    v-btn(fab dark small color='red'  @click.stop='openDeleteDialog(props.item)')
                        v-icon(small) mdi-delete
        v-container(v-else)
          .text-center(style="display:flex; align-items:flex-start;margin-left: 15px !important").mt-2
            .text-center(style="display:flex; align-items:center;")
              v-select.elevation-0.mr-4(
              :label="$t('expenses.filter_by_store')",
              :items='field.locations || []',
              v-model='currentLocation',
              item-text='full_name',
              return-object, dense='', solo='',
              clearable='', @input='selectShop',
              @click:clear='clearShopSelection')
                template(v-if='data.item' slot='selection', slot-scope='data')
                  v-flex(xs2='')
                    v-avatar(size='25px')
                      img( v-if='!!data.item' width='25' style='object-fit:cover;' :src='data.item.pictures.imageInput1')
                  v-flex.ml-1(style='font-size:10px; color :#000;')
                    | {{ data.item.name }}
                template(v-if='data.item' slot='item', slot-scope='data' )
                  v-row
                    v-avatar
                      img(v-if='!!data.item' width='25' style='object-fit:cover;' :src='data.item.pictures.imageInput1')
                    b {{data.item.name}}
            v-menu(v-model='menu', :close-on-content-click='false', :nudge-width='200', nudge-top offset-x='')
              template(v-slot:activator='{ on }')
                v-btn(color='#3cbbc2' small dark='', v-on='on' style="height: 38px;").mt-0
                  v-icon mdi-calendar
              v-card(style="border:3px solid #3cbbc2;").pa-2
                date-filter(@closeMenu="menu = false" :currentType= 'currentType',)
            //-
              v-btn(v-if="!isMobile" medium color='#3cbbc2' @click="createItem").mx-8
                v-icon(left='' small) mdi-plus
                | {{$t('expenses.expenses_bill')}}
          v-row.mt-2.mb-8.pr-4
            v-col(cols="6" @click="createItem").pr-1
              v-btn.ma-2.white--text.btn-transaction(block)
                | {{$t('expenses.expenses_bill')}}
                v-icon(right="" dark="")
                  | mdi-plus
            v-col(cols="6" @click="fetch()").pl-0
              v-btn.ma-2.white--text.btn-transaction(block)
                | Actualizar
                v-icon(right="" dark="")
                  | mdi-refresh
          //-
            v-card(v-if="isMobile" style='margin: 2px;' flat link @click="createItem" height="20" outlined).category-card.py-6.mx-4
              v-layout(pa-1 pl-2).text-center
                v-layout(xs12='' style="z-index: 0;").justify-space-around.align-center
                  span.h2.text-uppercase.text-center.d-flex.justify-center.align-center(style="width: 350px;") Agregar {{$t('expenses.expenses_bill')}}
                    img.mr-4.ml-2(style='height:36px' :src="addExpenseIcon")
            v-card(v-if="isMobile" style='margin: 2px;' flat link @click="fetch()" height="20" outlined).category-card.py-6.mx-4.mb-8
              v-layout(pa-1 pl-2).text-center
                v-layout(xs12='' style="z-index: 0;").justify-space-around.align-center
                  span.h2.text-uppercase.text-center.d-flex.justify-center.align-center(style="width: 350px;") Actualizar
                    img.mr-4.ml-2(style='height:36px' :src="updateIcon")
          v-row.px-2
            v-col(cols="12")
              mobileCard(color='cyan', icon='mdi-currency-usd', valueIcon='$' :title="$t('expenses.total')", :value=' transactionTotals.total.toFixed(2)')
            v-col(cols="12")
              mobileCard(v-if ='!!transactions'  color='warning', icon='mdi-swap-vertical', valueIcon='#' :title="$t('expenses.movements')", :value='transactions.length.toString()')
          v-card
            v-progress-linear(v-if="loading" indeterminate color="cyan")
            v-flex(md12='' style="max-width: 700px").mx-auto.mt-3
              v-list(two-line="" v-if="filteredTransactions.length > 0")
                  v-list-item-group
                    template(v-for="(item, index) in filteredTransactions.slice(10*(page-1), 10*(page))")
                      v-list-item(:key="item.reference_number").notification
                          template(v-slot:default="{ active, toggle }")
                              v-list-item-content(@click="openDetail(item)")
                                  p.font-weight-bold {{ item.title}}
                                  p.mt-2 {{ item.location_to.name}}
                                  p.mt-2.notification__date {{item.time | moment}} {{item.time | momentHours}}
                                  p.mt-2 {{ item.description}}
                                  p.mt-2 {{ item.typeExpense}}
                                  p.mt-2.font-weight-bold.notification__price {{ item.amount | numberFormat}}
                              v-lis-item-action
                                v-btn(fab dark small color='green' @click.stop='editItem(item)')
                                  v-icon(small) mdi-pen
                                v-btn(fab dark small color='red'  @click.stop='openDeleteDialog(item)')
                                  v-icon(small) mdi-delete
                          v-divider(v-if="index + 1 < filteredTransactions.length" :key="index")
                    v-pagination.my-4(v-model="page" :length="pageNumber")
              template(v-else)
                NoResults(title="No tienes gastos", description="Puedes ver tus gastos en otro rango de fechas")
</template>

<script>
  import Swal from 'sweetalert2'
  import moment from 'moment'
  import DateFilter from '@/components/custom/filters/DateFilter'
  import ExpensesForm from '@/components/custom/forms/ExpenseForm'
  import BillPreview from '@/components/custom/preview/transactions/ExpensesBillPreview'
  import loaders from '@/plugins/mixins/loaders'
  import addExpenseIcon from '@/assets/icons/home/gastos.png'
  import updateIcon from '@/assets/icons/home/update.png'
  const formatter = new Intl.NumberFormat('es-US', {
    style: 'currency',
    currency: 'COP',
    minimumFractionDigits: 0,
  })
  export default {
    components: {
      BillPreview: BillPreview,
      ExpensesForm: ExpensesForm,
      DateFilter: DateFilter,
      NoResults: () => import('@/components/custom/NoResults'),
      Details: () => import('@/views/marketplace/component/profile/RequestDetails'),
      mobileCard: () => import('@/views/custom/transactions/MobileCard.vue'),
      MovementTransactions: () => import('@/components/custom/transactions/movement_transactions'),
    },
    filters: {
      shortName (val) {
        if (val.length > 50) {
          return val.substring(0, 50) + '...'
        } else {
          return val
        }
      },
      moment: function (date) {
        return moment(date).format('DD/MM/YYYY')
      },
      momentHours: function (date) {
        return moment(date).format('hh:mm a')
      },
      moneyFormat: function (value) {
        return formatter.format(value)
      },
      numberFormat (val) {
        if (val) { return '$' + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') }
        return '0 '
      },
      translate: function (name) {
        switch (name) {
          case 'sales':
            return 'Venta'

          case 'purchases':
            return 'Compra'

          case 'expenses':
            return 'Gastos'

          case 'transfers':
            return 'Traslado'

          case 'returns':
            return 'Devolucion'

          case 'store':
            return 'Tienda'

          case 'warehouse':
            return 'Bodega'
        }
      },

    },
    mixins: [loaders],
    data () {
      return {
        loading: false,
        updateIcon,
        addExpenseIcon,
        currentRequest: '',
        detailsDialog: false,
        page: 1,
        menu: false,
        currentLocation: null,
        select: {},
        confirmationDialog: false,
        currentItemDelete: null,
        currentTransaction: null,
        selectedItem: {},
        purchaseDialog: false,
        transferDialog: false,
        expensesDialog: false,
        showBillDialog: false,
        search: '',
        currentItem: '',
        currentType: '',
        expenses: 0,
        // EXPENSES VARIABLES
        updateItemDialog: false,
        headers: [

          {
            sortable: true,
            text: this.$t('expenses.table_headers.spending_reason'),
            value: 'title',
            align: 'center',
          },
          {
            sortable: true,
            text: this.$t('expenses.table_headers.descp'),
            value: 'description',
            align: 'center',
          },
          {
            sortable: true,
            text: this.$t('expenses.table_headers.time'),
            value: 'time',
            align: 'left',

          },
          {
            sortable: true,
            text: this.$t('expenses.table_headers.amount'),
            value: 'amount',
            align: 'left',
          },
          {
            sortable: true,
            text: this.$t('expenses.table_headers.type_expense'),
            value: 'typeExpense',
            align: 'left',
          },
          {
            sortable: true,
            text: this.$t('expenses.table_headers.store'),
            value: 'location_to.name',
            align: 'left',
          },
          {
            text: this.$t('expenses.table_headers.actions'),
            align: 'left',
          },
        ],
      }
    },
    computed: {
      isMobile () {
        return window.innerWidth < 1024
      },
      /* loading () {
        return this.$store.getters['loading/getLoading']
      }, */
      // --FINISH EXPENSES
      getCurrentType () {
        return this.$store.getters['transactions/getCurrentType']
      },
      field () {
        return {
          locations: this.$store.getters['shops/getItems'],
        }
      },
      currentShop () {
        return this.$store.getters['shops/getCurrentItem']
      },
      transactions () {
        const vm = this
        if (vm.currentShop && vm.$store.getters['transactions/getLog']) {
          return vm.$store.getters['transactions/getLog'].filter((el) => {
            if (el.type !== 'purchases') {
              if (el.location_to.id === vm.currentShop.id) {
                return true
              }
            } else {
              if (el.location_to.id === vm.currentShop.id) {
                return true
              }
            }
          }).reverse()
        } else if (vm.$store.getters['transactions/getLog']) {
          return vm.$store.getters['transactions/getLog'].reverse()
        } else {
          return vm.$store.getters['transactions/getLog']
        }
      },
      transactionTotals () {
        const vm = this
        let total = 0
        if (vm.transactions) {
          const list = vm.transactions || {}
          list.forEach(element => {
            // if( Vue.moment().isSame(element.time, state.currentDateFilter))
            total += +element.amount
          })
          return {
            total: total,
          }
        }
        return {
          total: 0,
        }
      },
      pageNumber () {
        if (this.isMobile) {
          return Math.ceil(this.filteredTransactions.length / 10)
        } else {
          return Math.ceil(this.transactions.length / 10)
        }
      },
      filteredTransactions () {
        return this.transactions.filter((transaction) => {
          return (transaction.location_to.name.toLowerCase().match(this.search.toLowerCase()) || transaction.reference_number.toString().includes(this.search))
        })
      },
    },
    watch: {
      transactions (val, oldval) {
        // console.log(val, oldval)
        const vm = this
        vm.loading = false
      },
      $route (to, from) {
        // react to route changes...
        if (this.$route.params.type) {
          this.currentType = this.$route.params.type
          // console.log(this.$route.params.type)
        } else this.currentType = 'sales'
      },
    },
    created () {
      // console.log(this.$route.params.type)
      this.currentType = this.$route.params.type
      this.fetch()
    },
    beforeDestroy () {
      this.$store.dispatch('transactions/clearTransactions').then(function (res) {
        // console.log('transactions cleared')
      })
      this.clearShopSelection()
    },
    methods: {
      openDetail (item) {
        const vm = this
        vm.currentRequest = item
        vm.detailsDialog = true
      },
      // Expenses
      refresh () {
        const vm = this
        vm.fetch()
      },

      showBill (item) {
        // console.log(item)
        this.currentTransaction = item
        this.showBillDialog = !this.showBillDialog
      },

      createItem () {
        const vm = this
        vm.currentItem = {
          title: '',
          description: '',
          amount: '',
          type: '',
          location_to: null,
          pictures: {
            imageInput1: '',
          },
        }
        vm.expensesDialog = true
      },

      editItem (item) {
        const vm = this
        vm.currentItem = item
        vm.expensesDialog = true
        // console.log(item)
        /* this.$store.dispatch('expenses/setCurrentItem',{context: 'properties', id: id}).then(function(){
            vm.updateItemDialog = true;
        }); */
      },

      openDeleteDialog (item) {
        // console.log(item)
        const vm = this
        vm.currentItemDelete = item
        Swal.fire({
          title: 'Eliminar Gastos',
          text: '¿Deseas continuar?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#2ca0a5',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Si',
          cancelButtonText: 'No',
        }).then((result) => {
          if (result.isConfirmed) {
            vm.deleteItem(vm.currentItemDelete)
          }
        })
        /* vm.confirmationDialog = true
        vm.localLoad = true */
      },
      deleteItem (item) {
        // console.log(item)
        const vm = this
        this.$store.dispatch('transactions/deleteBill', item).then(function () {
          vm.confirmationDialog = false
          vm.dialog = false
          vm.fetch()
        },
        ).catch(function (err) {
          console.log(err)
          vm.confirmationDialog = false
          vm.dialog = false
        })
      },

      // -- FINISH EXPENSES

      showSupportImage (url) {
        this.$swal({
          title: 'Soporte',
          text: 'Modal with a custom image.',
          // imageUrl: url,
          imageWidth: 400,
          imageHeight: 200,
          imageAlt: 'Custom image',
          html: `
              <a target="_blank" href="${url}" download>
                <img style='max-height: 500px;' src="${url}" alt="comprobante">
              </a>
                    `,
          showConfirmButton: true,
        })
      },
      loadLog (type, dateFrom, dateTo) {
        const vm = this
        vm.$store.dispatch('transactions/loadLog', [type, dateFrom, dateTo, false]).then(function () {
          vm.loading = false
        })
      },
      fetch (type = 'expenses') {
        // vm.$store.commit('setLoading',true);
        const vm = this
        vm.loading = true
        // console.log('aaaaaa', vm.loading)
        const dateFrom = this.$moment().format('YYYY-MM-DD')
        this.loadLog(type, dateFrom, this.$moment(dateFrom).add(1, 'days').format('YYYY-MM-DD'))
      },

      clearShopSelection () {
        const vm = this
        vm.$store.dispatch('shops/setCurrentItem', null).then(function () {
        })
      },
      selectShop (item) {
        const vm = this
        // console.log(item)
        vm.$store.dispatch('shops/setCurrentItem', item).then(function () {
          // console.log(vm.$store.getters['shops/getCurrentItem'])
        })
      },

      close (dialog) {
        // console.log('cerro')
        const vm = this
        switch (dialog) {
          case 'expensesDialog':
            vm.expensesDialog = false
            break
        }
      },

    },
  }
</script>

<style lang='scss' scoped>
.expenses-container{
  .create-btn{
    justify-content: center;
  }
  @media(min-width: 600px) {
    .create-btn{
      justify-content: end !important;
    }
  }
  .card-transactions{

    overflow-y: scroll !important;
    &::-webkit-scrollbar {
      display: none;
    }
  }
  .show-table-mobile{
    padding-bottom: 50px;
  }
  @media(min-width: 760px) {
    .show-table-mobile{
      display: none !important;
    }
    .show-table-desktop{
      display: block !important;
    }
  }
  @media(max-width: 1100px) {
    .show-table-mobile{
      display: flex !important;
    }
    .show-table-desktop{
      display: none !important;
    }
  }
  .notification{
    display: flex;
    width: 95%;
    margin: 0 auto;
    // border-radius: 10px !important;
    box-shadow: -7px 4px 38px rgba(0, 0, 0, 0.16);
    &__container{
      @media (max-width: 1024px){
        background: transparent;
      }
    }
    &__date{
      font-size: 13px;
      color: #808184;
    }
    &__price{
      color: #35a3a9 !important;
    }
    &__description{
      color: #808184;
      font-size: 18px;
      font-weight: 300;
      line-height: 1.2;
    }
  }
  .expenses {
    &__title {
      text-align: center;
      color:#a3a4a5;
    }
    &__underline {
      position: relative;
      &:after {
        content:' ';
        position: absolute;
        top:120%;
        left:50%;
        width: 8rem;
        border:2px solid #30b5bb;
        border-radius:4px;
        transform:translateX(-50%);
      }
    }
  }
}
</style>
